import React from 'react';

const GoogleIcon = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.72 12.16c0-.497-.044-.975-.127-1.433H12v2.708h3.767a3.22 3.22 0 01-1.396 2.113v1.756h2.262c1.323-1.218 2.087-3.013 2.087-5.145z"
      fill="#5385EC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 19c1.89 0 3.475-.627 4.633-1.696l-2.262-1.756c-.627.42-1.43.668-2.371.668-1.823 0-3.366-1.232-3.917-2.886H5.745v1.814A6.997 6.997 0 0012 19z"
      fill="#59A55C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.083 13.33c-.14-.42-.22-.869-.22-1.33 0-.461.08-.91.22-1.33V8.856H5.745a6.997 6.997 0 000 6.288l2.338-1.814z"
      fill="#F1BE42"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 7.784c1.028 0 1.95.353 2.676 1.047l2.008-2.008C15.47 5.693 13.887 5 12 5a6.997 6.997 0 00-6.255 3.856l2.338 1.814c.55-1.655 2.094-2.886 3.917-2.886z"
      fill="#D75140"
    />
  </svg>
);

export default GoogleIcon;
